import { I18n } from "@assets/strings";
import React from "react";
import { useSuggestedCourses } from "@domain/lms/course/hooks";
import { Carousel } from "@ui/components/carousel/carousel";
import { CourseThumbnailSmall } from "@ui/components/course/courseThumbnailSmall";

type FeedCourseSuggestionsProps = React.HTMLAttributes<HTMLDivElement>;
export const FeedCourseSuggestions: React.FC<FeedCourseSuggestionsProps> = ({ ...htmlProps }) => {
	const { result: courses, loading } = useSuggestedCourses(5);

	return (
		<Carousel
			{...htmlProps}
			style={{ marginTop: 20 }}
			items={courses ?? []}
			renderItem={(course) => <CourseThumbnailSmall key={course.id} course={course} bannerHeight={254} />}
			title={I18n.t("feed.suggestions.courses")}
			loading={loading}
		/>
	);
};
